import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { COMPONENT_CALLER_TYPE } from 'commons/constants';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
const usePDPProductLabel = (id, slug, t0) => {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hookOptions = t1;
  const {
    productSku
  } = hookOptions;
  let t2;
  if ($[2] !== productSku) {
    t2 = {
      skipPDPStateHook: false,
      productSku
    };
    $[2] = productSku;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData
  } = usePDPBasicDetails(id, slug, t2);
  const productOptionData = usePDPOptions();
  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData
  } = productOptionData;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      callerType: COMPONENT_CALLER_TYPE.PDP
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    error: clearanceDataError,
    data: clearanceData
  } = usePDPClearanceData(id, slug, t3);
  const {
    isClearance
  } = clearanceData;
  basicData?.custom_properties?.product_label;
  optionsData?.stock?.isSelectedOptionsQuickship;
  optionsData?.stock?.selectedOptionsStockQty;
  let label = null;
  if (optionsData?.stock?.isSelectedOptionsQuickship && optionsData.stock.selectedOptionsStockQty <= 3) {
    label = "Low Stock";
  }
  if (isClearance) {
    label = "Final Sale";
  }
  if (basicData?.custom_properties?.product_label?.[0]) {
    label = basicData?.custom_properties?.product_label;
  }
  const productLabel = label;
  const t4 = basicLoading || optionsLoading;
  const t5 = basicError || optionsError || clearanceDataError;
  let t6;
  if ($[5] !== productLabel) {
    t6 = {
      productLabel
    };
    $[5] = productLabel;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = {
      loading: t4,
      error: t5,
      data: t6
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default usePDPProductLabel;